import React from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Download, FileSpreadsheet, FileText, FileType } from "lucide-react";
import { exportXLSX, exportCSV, exportPDF } from "@/lib/export";

/**
 * columns: [{ key, label, format? }]
 */
export default function ExportButton({ rows, columns, title, filename, testid }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="border-slate-200" data-testid={testid || "export-btn"}>
          <Download className="w-4 h-4 mr-1"/> Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem onClick={()=>exportXLSX(rows, columns, filename)}><FileSpreadsheet className="w-4 h-4 mr-2 text-emerald-600"/> Excel (.xlsx)</DropdownMenuItem>
        <DropdownMenuItem onClick={()=>exportCSV(rows, columns, filename)}><FileText className="w-4 h-4 mr-2 text-sky-600"/> CSV</DropdownMenuItem>
        <DropdownMenuItem onClick={()=>exportPDF(rows, columns, title, filename)}><FileType className="w-4 h-4 mr-2 text-red-600"/> PDF</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
